(function (Drupal) {
  Drupal.behaviors.nerivioStepAccordion = {
    attach: function (context, settings) {
      const accordions = context.querySelectorAll('.step-accordion:not([data-nerivio-step-accordion-processed])');

      accordions.forEach((accordion) => {
        accordion.setAttribute('data-nerivio-step-accordion-processed', 'true');

        const contentWrapper = accordion.querySelector('.step-accordion__content');
        const items = accordion.querySelectorAll('.step-accordion__item');
        const readMoreContainer = accordion.querySelector('.step-accordion__read-more');
        const readMoreLink = readMoreContainer ? readMoreContainer.querySelector('a') : null;

        if (contentWrapper && contentWrapper.classList.contains('On')) {
          accordion.classList.add('expanded');

          items.forEach((item) => {
            const desc = item.querySelector('.step-accordion__item-description');
            if (desc) {
              desc.classList.add('is-open');
            }
          });

          if (readMoreContainer) {
            readMoreContainer.style.display = 'none';
          }

          return;
        }

        if (readMoreLink) {
          readMoreLink.addEventListener('click', function (e) {
            e.preventDefault();

            const isExpanded = accordion.classList.contains('expanded');
            const textSpan = this.querySelector('span');

            if (!isExpanded) {
              accordion.classList.add('expanded');
              items.forEach((item) => {
                const desc = item.querySelector('.step-accordion__item-description');
                if (desc) desc.classList.add('is-open');
              });
              if (textSpan) textSpan.textContent = 'Read Less';
            } else {
              accordion.classList.remove('expanded');
              items.forEach((item) => {
                const desc = item.querySelector('.step-accordion__item-description');
                if (desc) desc.classList.remove('is-open');
              });
              if (textSpan) textSpan.textContent = 'Read More';
            }
          });
        }
      });
    }
  };
})(Drupal);
